import { useCallback } from 'react';

import { checkUserAuthType, getDecodedToken } from '@webclient/lib/jwt';

import useAppDispatch from '@webclient/hooks/useAppDispatch';

import { setHasSecureAccount, setMe } from '@webclient/state/slices/auth';

export default function useUpdateMe() {
  const dispatch = useAppDispatch();

  const handleUpdateMe = useCallback(
    (token: string) => {
      const authType = checkUserAuthType(token);
      dispatch(setHasSecureAccount(!authType?.match(/_fingerprint$/)));
      dispatch(setMe(getDecodedToken(token)));
    },
    [dispatch],
  );

  return { handleUpdateMe };
}
